export default "__VITE_ASSET__Bc99TNeO__"